import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 30 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.95, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Eyebrow = ({ children, light = false, testId }) => (
  <p
    data-testid={testId}
    className={`text-[0.68rem] uppercase tracking-[0.3em] font-semibold mb-5 flex items-center gap-3 ${
      light ? "text-[#8a6f35]" : "text-[#C9A75D]"
    }`}
  >
    <span className="inline-block w-8 h-px bg-current" />
    {children}
  </p>
);

export const Placeholder = ({ text }) => (
  <span className="ph-copy">[ {text} ]</span>
);

export const Cta = ({ to, href, variant = "solid-light", children, testId, onClick }) => {
  const cls = `btn btn-${variant}`;
  if (href)
    return (
      <a data-testid={testId} href={href} className={cls} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer">
        {children}
      </a>
    );
  if (onClick)
    return (
      <button data-testid={testId} onClick={onClick} className={cls}>
        {children}
      </button>
    );
  return (
    <Link data-testid={testId} to={to} className={cls}>
      {children}
    </Link>
  );
};

export const FounderFrame = ({ label = "E & C", caption = "Fotografia ufficiale di Elio & Chiara — in arrivo", ratio = "aspect-[4/5]", light = false }) => (
  <div className={`relative ${ratio} w-full overflow-hidden grain ${light ? "bg-[#D8C7AA]" : "bg-[#1a1812]"}`}>
    <div className="absolute inset-3 border border-[#C9A75D]/40" />
    <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-8">
      <span className={`font-display text-6xl sm:text-7xl font-light ${light ? "text-[#0B0B0B]/80" : "text-[#D8C7AA]"}`}>
        {label}
      </span>
      <span className={`mt-4 text-[0.65rem] uppercase tracking-[0.25em] ${light ? "text-[#0B0B0B]/55" : "text-[#D8C7AA]/55"}`}>
        {caption}
      </span>
    </div>
  </div>
);

export const SectionHead = ({ eyebrow, title, light = false, center = false, testId }) => (
  <Reveal className={center ? "text-center flex flex-col items-center" : ""}>
    <Eyebrow light={light} testId={testId}>{eyebrow}</Eyebrow>
    <h2
      className={`font-display text-2xl sm:text-3xl lg:text-4xl font-medium tracking-tight leading-[1.12] whitespace-pre-line ${
        light ? "text-[#0B0B0B]" : "text-[#F7F4EE]"
      }`}
    >
      {title}
    </h2>
  </Reveal>
);
